


















































































































































































import moment from "moment";
import { Intervention } from "../../models/Intervention";

export default {
    name: "RecurringInterventionRow",
    props: {
        intervention: {
            type: Object,
            required: true,
        },
        selectMode: {
            type: Boolean,
            default: false,
        },
        selectAll: {
            type: Boolean,
            default: false,
        },
        frequences: {
            type: Object,
            default: () => ({}),
        },
    },
    data() {
        return {
            now: moment(),
            jours: {
                1: "Lun",
                2: "Mar",
                3: "Mer",
                4: "Jeu",
                5: "Ven",
                6: "Sam",
                7: "Dim",
            },
        };
    },
    methods: {
        onSelect() {
            this.$emit("selected", this.intervention);
        },
        editIntervention() {
            if (!this.selectMode) {
                this.$emit("action", "edit-intervention", this.intervention);
            }
        },
        deleteIntervention() {
            this.$emit("action", "delete-intervention", this.intervention);
        },
        // Archive
        restoreIntervention() {
            this.intervention.archived = false;
            this.$emit("action", "update-intervention", this.intervention);
        },
        archiveIntervention() {
            this.intervention.archived = true;
            this.$emit("action", "update-intervention", this.intervention);
        },
        //
        formatDate(date) {
            if (!date) return "";
            return moment(date).format("DD/MM/YYYY");
        },
        getFrequenceName(frequenceId) {
            if (this.frequences[frequenceId]) {
                return this.frequences[frequenceId].name;
            }
        },
        getJourStr(jourId) {
            return this.jours[jourId] || "";
        },
        getNextDateStr(jours) {
            let date = moment(
                _.chain(jours).map("next_date").sortBy().first().value()
            );
            if (date.isValid()) {
                return date.format("DD/MM/YYYY");
            }
        },
        isBeforeStartDate(startDate) {
            if (!startDate) return false;
            return this.now.isBefore(moment(startDate));
        },
        isAfterEndDate(endDate) {
            if (!endDate) return false;
            return this.now.isAfter(moment(endDate));
        },
    },
    computed: {
        filteredRemplacements() {
            let res = _.chain(this.intervention.remplacements)
                .filter(function (remplacement) {
                    if (remplacement.end_date) {
                        return (
                            remplacement.end_date >=
                            moment().format("YYYY-MM-DD")
                        );
                    } else {
                        return (
                            remplacement.start_date >=
                            moment().format("YYYY-MM-DD")
                        );
                    }
                })
                .forEach(function (remplacement) {
                    let endDate = moment(remplacement.end_date);
                    if (remplacement.end_date && endDate.isValid()) {
                        remplacement.after_end_date = endDate
                            .add(1, "d")
                            .format("YYYY-MM-DD");
                    }
                })
                .value();
            return res;
        },
    },
};
